module.exports = __webpack_public_path__ + "img/id-2.e411843f.png";